export const SUBMIT_MEMBER_SUCCESS = "SUBMIT_MEMBER_SUCCESS"
export const UPDATE_MEMBER_LIST_LOADING = "UPDATE_MEMBER_LIST_LOADING"
export const UPDATE_MEMBER_LIST_PAGINATION = "UPDATE_MEMBER_LIST_PAGINATION"
export const UPDATE_MEMBER_FORM_BY_ID = "UPDATE_MEMBER_FORM_BY_ID"
export const UPDATE_GROUP_DATAS = "UPDATE_GROUP_DATAS"
export const UPDATE_MEMBER_GROUP_LIST_FILTER = "UPDATE_MEMBER_GROUP_LIST_FILTER"